import React from 'react';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import { SxStyle } from '../../../types';

const styles: SxStyle = {
  paper: (theme) => ({
    marginRight: theme.spacing(2),
    width: '100%',
    overflow: 'hidden',
  }),
};

interface SubCollectionsProps {
  children: React.ReactNode;
}

function SubCollections({ children }: SubCollectionsProps) {
  if (children) {
    return (
      <Paper sx={styles.paper}>
        <MenuList>{children}</MenuList>
      </Paper>
    );
  }
  return null;
}

export default SubCollections;
